import urls from 'urls';
import {STORE_E_GIFT_CARDS} from '~/common/fabric/GiftCard/reducers/eGiftCard';

const logErrorMessage = (error) => {
  evite.error(`Error retrieving retailers list: ${error}`);
};

export const getRetailers = () => async (dispatch) => {
  let data = null;
  try {
    const response = await evite.fetch(urls.get('ajax_bhn_products'), {
      method: 'GET',
      credentials: 'include',
      headers: {
        'X-CSRFToken': window.evite.cookie('csrftoken'),
        accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    if (response.ok) {
      data = await response.json();
      if (data?.status !== 'ok') logErrorMessage(data?.status);
    } else {
      logErrorMessage(response?.status);
    }
  } catch (err) {
    logErrorMessage(err.message);
  }
  dispatch({type: STORE_E_GIFT_CARDS, payload: data?.products});
};
